import { FC } from 'react';
import styled from 'styled-components';

const MenuItemHeadingElement = styled.li`
  font-size: 12px;
  padding: 15px 20px 10px 20px;
  cursor: default;
  color: ${({ theme }) => theme.vars.newColor.darkGS3};
  text-transform: uppercase;
`;

export const SearchMenuItemHeading: FC = props => <MenuItemHeadingElement>{props.children}</MenuItemHeadingElement>;
